// material-ui
// import { useTheme } from '@mui/material/styles';
// import { useColorScheme } from '@mui/material/styles';

import logo from 'assets/images/logo.png';
 

export default function LogoMain() {
  // const theme = useTheme();
  // const { colorScheme } = useColorScheme();

  return (
     <img src={logo} alt="Diaspora Logo" width="60" />
  );
}
